<template>
  <button
    :key="`${section.key}-${document.sequentialNumber}`"
    :class="componentClasses"
    @click="() => clientPortalStore.selectDocument(document.sequentialNumber)"
  >
    <div class="document-count">
      {{ document.sequentialNumber }}
    </div>

    <div class="document-name">
      {{ documentName }}
    </div>

    <Icon :icon="icon" />
  </button>
</template>

stake

<script setup>
import { computed } from 'vue';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';
import { Icon } from '@stakeui';
import { prettifyMixedCase } from '@frontend/shared/Util.js';

const clientPortalStore = useClientPortalStore();

const props = defineProps({
  document: {
    type: Object,
    required: true,
  },
  section: {
    type: Object,
    required: true,
  },
});

const documentName = computed(() => prettifyMixedCase(props.document.name));

const icon = computed(() => {
  if (props.document.completed) {
    return 'fas fa-check-circle';
  }

  if (clientPortalStore.uploads.includes(props.document.id)) {
    return 'fas fa-spinner fa-pulse';
  }

  if (['not_applicable', 'dont_have', 'not_comfortable'].includes(props.document.status)) {
    return 'fas fa-ban';
  }

  return '';
});

const componentClasses = computed(() => [
  'stk-reset',
  'document-item',
  props.document.completed && 'is-completed',
  props.document.status && `status-${props.document.status}`,
  clientPortalStore.currentStep === 'upload' && clientPortalStore.isCurrentDocument(props.document.sequentialNumber) && 'is-selected',
]);
</script>

<style scoped>
.document-item {
  display: flex;
  align-items: center;
  gap: 0.25em;
  text-align: start;
  justify-content: start;
  line-height: 1.25;
  padding: 0.375em 0.5em;
  border-radius: 0.625em;
  font-weight: 500;
  color: var(--stk-text-normal);
  gap: 0.125em;
  transition-duration: var(--stk-transition-duration);
  transition-property: background-color, color;
  cursor: pointer;

  &:hover {
    background-color: var(--stk-background-alt);
    color: var(--stk-text-strong);
  }

  &.is-uploaded {
    background-color: var(--stk-success-90);
    color: var(--stk-success-40);
  }

  &.is-selected {
    background-color: var(--stk-primary-90);
    color: var(--stk-primary-40)
  }

}

.document-count {
  display: none;
  width: 1em;
  text-align: center;
  flex-shrink: 0;
  justify-content: center;
  font-size: 0.875em;
}

.document-name {
  flex-grow: 1;
}
</style>
